import store from '../atoms';
import { openInfoModalAtom } from '../atoms/modalAtoms';
import sleep from './sleep';
import tStatic from '../translations';
import { DICTIONARY } from '../translations/dictionary';

export default async ({
  request,
  setLoading,
  warnErrorText,
  payload,
  showErrorInModal = true,
  getFullResponse = false,
}) => {
  try {
    if (setLoading) {
      setLoading(true);
    }
    const response = await request(payload);
    const { data } = response;

    if (data?.status === 'failed') {
      const error = new Error(data.message);
      error.response = { data };
      throw error;
    }

    return getFullResponse ? response : data;
  } catch (e) {
    console.warn(e?.response?.data, warnErrorText);
    if (showErrorInModal) {
      sleep(200).then(() => (
        store.set(openInfoModalAtom, {
          text: e?.response?.data?.message || tStatic(DICTIONARY.error),
          // onButtonClick: () => onErrorModalClose(e),
        })
      ));
    }
    return e?.response?.data;
  } finally {
    if (setLoading) {
      setLoading(false);
    }
  }
};
